module.exports = __webpack_public_path__ + "img/T925.85f17325.jpg";